/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState,useRef,useEffect } from 'react';
import PropTypes, { object } from 'prop-types';
import 'react-datepicker/dist/react-datepicker.css';
import FormValidation from '../../atoms/formEnums/formValidation';
import './formCameraPresentationComponent.scss';
import Button from '../../atoms/button/button';
import ModalBootstrap from 'react-bootstrap/Modal';
import { ButtonGroup, Col, Form, Row, ToggleButton } from 'react-bootstrap';
import { storeStructure } from '../../../store/reducers';
import { useDispatch, useSelector } from 'react-redux';
import { CompactPicker } from 'react-color';
import camNoImage360 from '../../atoms/customIcons/noimagecamera360.png';
import camNoImage180 from '../../atoms/customIcons/noimagecamera180.png';
import camNoImageFlat from '../../atoms/customIcons/noimagecameraFlat.png';
import FormExternalResource from '../formExternalResource/formExternalResource';
import FormInputTypes from '../../atoms/formEnums/formInputTypes';
import { httpGet } from '../../../store/externalCalls/httpCalls';
import InputText from '../../atoms/inputText/inputText';


var holdingCam=null;
var highlightCam=null;
let updateTimeout=null;
/**
 * Form Input Text is a basic HTML input field, label, error text and HelpButton.
 * It is designed to send the input value to a parent component, such as organisms Form,
 * and to shows the validation state of the field provided by the parent component.
 */
const FormCameraPresentationComponent = (props) => {
  const {
    value,stepData,onUpdate,visibleWhen, onUpdateCameras
  } = props;
  const DEFAULT_CAM_WIDTH=20;
  const DEFAULT_CAM_HEIGHT=20;
  const DEFAULT_WIDTH=400;
  const DEFAULT_CAM_SIZE=40;
  //listener to uploadables
  const Uploadables = useSelector((state) => state[storeStructure.DownloadableFiles]);

  //canvas definitions
  const canvasSpacesRef = useRef(null);
  const canvasDragRef = useRef(null);
  const canvasCamsRef = useRef(null);
  const canvasBackgroundRef=useRef(null);
  const canvasImageRef=useRef(null);
  const canvasHighlightRef=useRef(null);

  const[mainWidth,setMainWidth] =useState(400);
  const[mainHeight,setMainHeight] =useState(200);

  const [popupValues,setPopupValues] =useState({});
  const [newValues,setNewValues] =useState({});
  const [showPopup,setShowPopup] =useState(false);
  const [popupData,setPopupData] =useState(null);
 
  const [offset,setOffset] =useState({});
  
  const [mainMap,setMainMap] =useState(null);
  const [mainBkMap,setMainBkMap] =useState(null);
  const [mainMobileMap,setMainMobileMap] =useState(null);
  const [mainMobileBkMap,setMainMobileBkMap] =useState(null);

  const [mapDisplayed,setMapDisplayed] =useState(null);
  const [icon180,setIcon180] =useState({});
  const [bkDisplayed,setBkDisplayed] =useState(null);
  const [icon360,setIcon360] =useState({});
  const [iconFlat,setIconFlat]=useState({})
  const [spaces,setSpaces]=useState([]);
  const [resetCams180,setResetCams180] =useState({});
  const [resetCams360,setResetCams360] =useState({});
  const [resetCamsFlat,setResetCamsFlat] =useState({});
  const [camerasToSignaling,setCamerasToSignaling] =useState([]);

  const [mainImg,setMainImg] =useState(null);
  const [pixelSize,setPixelSize] =useState({width:DEFAULT_CAM_WIDTH,height:DEFAULT_CAM_HEIGHT});
  const [preview,setPreview] =useState(false);

  const [cams,setCams]=useState([]);
  const [isMouseDown,setIsMouseDown]=useState(false);
  const [cursorOffset,setCursorOffset]= useState(null);
  const [mapModeSelected,setMapModeSelected] =useState("1");
  const viewMapModes = [
    { name: 'VR / Web', value: '1' },
    { name: 'Mobile', value: '2' },
  ];

  let offsetBackground=20;
  let minPosX = 0;
  let numberPosX = 40;
  let minPosY = 0;
  let numberPosZ = 40;
  let new_min = -1;
  let new_max = 1;

  let new_min_y = 1;
  let new_max_y = -1;
  let padding_left=0;
  let padding_top=0;

  
  const scale = (number, inMin, inMax, outMin, outMax)=> {
    return (number - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
  }
  const updateCamera = (data) => {

    if(data.composeExperienceMulticamComposer){
      data.composeExperienceMulticamComposer.map((camera) => {
    
        data.cameras.forEach(existingCamera => {
    
          if(camera.name === existingCamera.name)
          {
            existingCamera.cameraName = camera.cameraName;
          }
    
        })
    
      })
    }
  }

  const addCamera = (data) => {
    const vodToAdd = data.composeExperienceMulticamComposer[data.composeExperienceMulticamComposer.length-1]
    
    let cameraName = '';
    let name = '';
    let type = '';
    let newId = stepData.cameras.length+1;
    if(vodToAdd.hasOwnProperty('VoD'))
    {
      cameraName = vodToAdd.cameraName ?? 'Camera '+newId;
      name = vodToAdd.VoD[0].name ;
      type = vodToAdd.VoD[0].type;
      stepData.type = type;
    }
    else 
    {
      cameraName = vodToAdd.cameraName ?? 'Camera '+newId;
      name = vodToAdd.vodToAdd.name ;
      type = vodToAdd.type;
      
    }
    if(vodToAdd.VoD !== undefined)
      {
          if(type!='croom'){
        

            const newCamera = {
              id: newId,
              cameraName,
              name,
              type,      
              viewPoint: [{
                id: newId,
                name,
      
              positionX: 0,
              positionY: 0,
              positionZ: 0,
              rotationX: 0,
              rotationY: 0,
              rotationZ: 0,
              scale: 1
            }]
            
          }
        
          onUpdate({target: {value:[...value,newCamera]}})
        }
      }
    
  }

  const deleteCamera = (cameraToDelete) => {
    const finalCameras = [...value];
    const cleanVod = finalCameras.filter((camera) => camera.name != cameraToDelete);
    cleanVod.map((camera,index) => camera.id=index+1)
    onUpdate({target: {value:cleanVod}})

  }




  const setValueCamera =(objectCam,field,type)=>{
    let changes=objectCam.changes;
    if(objectCam.values!={} || (Object.keys(objectCam).length>0 && objectCam.values[field])){
      if(objectCam && Object.keys(objectCam).length>0 && objectCam.values[field]){
        if(objectCam.values[field].id!=stepData["mapConfig"][0][field+type]["id"]){ //changes on camera icon
          changes={...objectCam.changes,[field]:stepData["mapConfig"][0][field+type]}
          if(type==180)
            setResetCams180(changes);
          else if(type==360)
            setResetCams360(changes);
          else if(type=="globe")
            setResetCams360(changes);
          else if(type=="croom")
            console.log("croom, ignoring camera placement")
          else
            setResetCamsFlat(changes);
          return {"values":{...objectCam.values,[field]:stepData["mapConfig"][0][field+type]},"changes":changes};  
        }else{ //no changes on camera icon
          return objectCam;
        }
      }else{ //initialization of object
        changes={...objectCam.changes};
        let values=objectCam.values;
       
        return {"values":{...values,[field]:stepData["mapConfig"][0][field+type]},"changes":changes};  
      }
    }
  }
  const getConfigCameraValues=(func)=>{
     //there is a change in cam images
     let values180={"values":icon180,"changes":[]};
     let values360={"values":icon360,"changes":[]};
     let valuesFlat={"values":iconFlat,"changes":[]};
     values180=setValueCamera(values180,"icon","180");
     values180=setValueCamera(values180,"highlight","180");
     values180=setValueCamera(values180,"selected","180");
     values180=setValueCamera(values180,"mobileIcon","180");
     values180=setValueCamera(values180,"mobileSelected","180");
    //  setIcon180(values180.values);
     values360=setValueCamera(values360,"icon","360");
     values360=setValueCamera(values360,"highlight","360");
     values360=setValueCamera(values360,"selected","360");
     values360=setValueCamera(values360,"mobileIcon","360");
     values360=setValueCamera(values360,"mobileSelected","360");

     valuesFlat=setValueCamera(valuesFlat,"icon","Flat");
     valuesFlat=setValueCamera(valuesFlat,"highlight","Flat");
     valuesFlat=setValueCamera(valuesFlat,"selected","Flat");
     valuesFlat=setValueCamera(valuesFlat,"mobileIcon","Flat");
     valuesFlat=setValueCamera(valuesFlat,"mobileSelected","Flat");
     
    //  setIcon360(values360.values);
    if(func){
      func(values180,values360,valuesFlat);
    }
  }

  useEffect(()=>{
      if(value != undefined)
      {
        paintMap(mapModeSelected);
      }
      
      if(stepData.composeExperienceMulticamComposer){
  
  
        // If the last element's name is not present in any of the cameras, add that element
        if(stepData.composeExperienceMulticamComposer.length > 0)
        {
          let lastElement = stepData.composeExperienceMulticamComposer[stepData.composeExperienceMulticamComposer.length-1];
          let found = false;
          for(let i=0;i<stepData.cameras.length;i++)
          {
            if(stepData.cameras[i].name == lastElement.name)
            {
              found = true;
            }
          }
          if(!found && lastElement.type !== 'croom')
          {
            addCamera(stepData)
          }
          
          // Is there any camera that is not present in the multicam composer? Delete it
  
          for(let i=0;i<stepData.cameras.length;i++)
          {
            let found = false;
            for(let j=0;j<stepData.composeExperienceMulticamComposer.length;j++)
            {
              if(stepData.cameras[i].name == stepData.composeExperienceMulticamComposer[j].name)
              {
                found = true;
                
              }
            }
            if(!found)
            {
              deleteCamera(stepData.cameras[i].name)
            }
          }
  
        }
         
      }

    
    
  },[mapModeSelected,stepData.composeExperienceMulticamComposer]);


  const paintMap=(mapModeSelected)=>{
    
    let main=null;
    let mainBK=null;
    resetCams();
    setMapDisplayed(null);
    setMainMap(null);
    setMainMobileMap(null);
    setMainImg(null);
    resetMap();
    if(mapModeSelected==1){
      main=stepData.mapConfig[0].mapId;
      mainBK=stepData.mapConfig[0].mapBKId;
      setMainMap(main);
    }else{
      
      main=stepData.mapConfig[0].mapMobileId;
      mainBK=stepData.mapConfig[0].mapMobileBKId;
      setMainMobileMap(main);
    }
    var ctx=canvasImageRef.current.getContext('2d');
      if(main && main.url){
        drawMap(ctx,main.url,'0.9','source-over',null,(img)=>{
            setMapDisplayed(main.url);
            setMainImg(img);
            drawSpaces(img);
            if(mainBK && mainBK.url){
              drawMap(ctx,mainBK.url,"0.4",'destination-over',img);
              setBkDisplayed(mainBK.url);
            }
        });
      }
  }

  useEffect(()=>{

      if(Object.keys(resetCams180).length>0){
        setResetCams180({});
      }
  
      if(Object.keys(resetCams360).length>0){
        setResetCams360({});
      }
      
      if(Object.keys(resetCamsFlat).length>0){
        setResetCamsFlat({});
      }
    
  },[resetCams180,resetCams360,resetCamsFlat]);

  useEffect(()=>{ //once we have the map we draw the cams
 
    
    if(value != undefined){
      
        updateCamera(stepData)
        if(stepData["mapConfig"][0].mapId!=mainMap  && mapModeSelected==1){
          paintMap(mapModeSelected);        
        }
          getConfigCameraValues((values180,values360,valuesFlat)=>{        
                paintCameras(values180,values360,valuesFlat);
        });
      }

      
  },[value,mainImg,stepData["mapConfig"]]);


  const paintCameras=(generic180,generic360,genericFlat)=>{
    if(mainImg!=null){
      resetCams();
      let cams=extractInfo2(value,stepData,generic180,generic360,genericFlat);
      setCams(cams);
      setTimeout(()=>{
        
        drawCams(cams);  
      },100);
    }
  }

  const changeMapMode=(value)=>{
    setBkDisplayed(null);
    setMapDisplayed(null);
    setMapModeSelected(value);
  };

  const generateSpaces =(width,height)=>{
    let elems=[];
    for(let i=0;i<=numberPosX;i++){
      for(let j=0;j<=numberPosZ;j++){
        let v;
        let new_value_x;
        if(numberPosX - -minPosX==0)
          new_value_x="0.00";
        else
          new_value_x = (( ( i - -minPosX ) / (numberPosX - -minPosX) ) * (new_max - new_min) + new_min).toFixed(2);
        let new_value_z;
        if(numberPosZ - - minPosY==0)
          new_value_z="0.00";
        else  
          new_value_z = (( ( j - -minPosY ) / (numberPosZ - -minPosY) ) * (new_max_y - new_min_y) + new_min_y).toFixed(2);
        let color;
        if(new_value_x=="0.00" || new_value_z=="0.00")
          color="1";
        else
          color="0";
        elems.push({index_x:i,index_z:j,x:i*width+padding_left,z:j*height+padding_top,x_id:new_value_x,z_id:new_value_z,color:color});
      } 
    }
    return elems;
  }

  const drawSpaces=(imgSizes)=>{

    const existContext = canvasSpacesRef.current ?? false;

    if(existContext){
      var ctx=canvasSpacesRef.current.getContext('2d');
      let pixelWidth=DEFAULT_CAM_WIDTH;
      let pixelHeight=DEFAULT_CAM_HEIGHT;
      if(imgSizes){
        pixelWidth=imgSizes.pixelWidth;
        pixelHeight=imgSizes.pixelHeight;
      }
      let mySpaces=generateSpaces(pixelWidth,pixelHeight);
      setMainWidth(pixelWidth*(numberPosX+1)+80);
      setMainHeight(pixelHeight*(numberPosZ+1)+50);
      setSpaces(mySpaces);
      mySpaces.forEach(function(space) {
        drawSpace(space,pixelWidth,pixelHeight);
      });
      //draw marker 0 
      ctx.fillStyle = '#000000';
      ctx.textAlign="center"; 
      ctx.textBaseline = "middle";      
      //vertical
      ctx.fillText("0",numberPosX*pixelWidth+pixelWidth+10+padding_left,numberPosZ*pixelHeight/2+pixelHeight/2+padding_top);
      ctx.fillText("0.5",numberPosX*pixelWidth+pixelWidth+10+padding_left,numberPosZ*pixelHeight/4+pixelHeight/2+padding_top);
      ctx.fillText("-0.5",numberPosX*pixelWidth+pixelWidth+10+padding_left,numberPosZ*pixelHeight/4*3+pixelHeight/2+padding_top);
      ctx.fillText("1",numberPosX*pixelWidth+pixelWidth+10+padding_left,pixelHeight/2+padding_top);
      ctx.fillText("-1",numberPosX*pixelWidth+pixelWidth+10+padding_left,numberPosZ*pixelHeight+pixelHeight/2+padding_top);
      //horizontal
      ctx.fillText("0",numberPosX*pixelWidth/2+pixelWidth/2+padding_left,numberPosZ*pixelHeight+pixelHeight+10+padding_top);
      ctx.fillText("-0.8",numberPosX*pixelWidth/10*1+pixelWidth/2+padding_left,numberPosZ*pixelHeight+pixelHeight+10+padding_top);
      ctx.fillText("-0.6",numberPosX*pixelWidth/10*2+pixelWidth/2+padding_left,numberPosZ*pixelHeight+pixelHeight+10+padding_top);
      ctx.fillText("-0.4",numberPosX*pixelWidth/10*3+pixelWidth/2+padding_left,numberPosZ*pixelHeight+pixelHeight+10+padding_top);
      ctx.fillText("-0.2",numberPosX*pixelWidth/10*4+pixelWidth/2+padding_left,numberPosZ*pixelHeight+pixelHeight+10+padding_top);
      ctx.fillText("0.2",numberPosX*pixelWidth/10*6+pixelWidth/2+padding_left,numberPosZ*pixelHeight+pixelHeight+10+padding_top);
      ctx.fillText("0.4",numberPosX*pixelWidth/10*7+pixelWidth/2+padding_left,numberPosZ*pixelHeight+pixelHeight+10+padding_top);
      ctx.fillText("0.6",numberPosX*pixelWidth/10*8+pixelWidth/2+padding_left,numberPosZ*pixelHeight+pixelHeight+10+padding_top);
      ctx.fillText("0.8",numberPosX*pixelWidth/10*9+pixelWidth/2+padding_left,numberPosZ*pixelHeight+pixelHeight+10+padding_top);
      ctx.fillText("-1",pixelWidth/2+padding_left,numberPosZ*pixelHeight+pixelHeight+10+padding_top);
      ctx.fillText("1",numberPosX*pixelWidth+pixelWidth/2+padding_left,numberPosZ*pixelHeight+pixelHeight+10+padding_top);
      //x axis
      ctx.font="12px Verdana";
      ctx.fillText("(X Axis)",numberPosX*pixelWidth/2+pixelWidth/2+padding_left,numberPosZ*pixelHeight+pixelHeight+40+padding_top);
      //Y axis
      ctx.fillText("(Z Axis)",numberPosX*pixelWidth+pixelWidth+40+padding_left,numberPosZ*pixelHeight/2+pixelHeight/2+padding_top);
    }
  }

  const drawSpace=(space,pixelWidth=null,pixelHeight=null) =>{
    var ctx=canvasSpacesRef.current.getContext('2d');
    if(space.color=="1"){
      ctx.fillStyle = '#777777';    
      ctx.fillRect(space.x, space.z, pixelWidth, pixelHeight);
    }else{
      if((space.index_x+space.index_z)%2==0){
        ctx.fillStyle="#d9d9d9";
      }else{
        ctx.fillStyle="#f5f5f5";
      }
      ctx.fillRect(space.x, space.z, pixelWidth, pixelHeight);
    }
    ctx.lineWidth = 1;
    ctx.strokeStyle = '#ffffff';
    ctx.strokeRect(space.x, space.z, pixelWidth, pixelHeight);
  }

  
  
  const getCamPosition=(place,canvasX,canvasZ,pixelSize,camScaledSize,panelInfo)=>{
    let iconPositionX;
    let iconPositionZ;
    let textPositionX;
    let textPositionZ;
    let padding=5;
    switch(place){
      case "right":
        iconPositionX=canvasX+pixelSize.width+padding;
        iconPositionZ=canvasZ-camScaledSize.height/2+pixelSize.height/2;
        textPositionX=canvasX+30;
        textPositionZ=canvasZ-camScaledSize.height/2-panelInfo.height/2-padding;
        break;
      case "left":
        iconPositionX=canvasX-camScaledSize.width-padding
        iconPositionZ=canvasZ-camScaledSize.height/2+pixelSize.height/2;
        textPositionX=canvasX-camScaledSize.width-30;
        textPositionZ=canvasZ-camScaledSize.height/2-panelInfo.height/2-padding;  
        break;
      case "up":
        iconPositionX=canvasX-camScaledSize.width/2+pixelSize.width/2; 
        iconPositionZ=canvasZ-camScaledSize.height-padding;
        textPositionX=canvasX+pixelSize.width+padding+camScaledSize.width/2;
        textPositionZ=canvasZ-panelInfo.height/2-padding;
        break;
      case "down":
        iconPositionX=canvasX-camScaledSize.width/2+pixelSize.width/2;
        iconPositionZ=canvasZ+pixelSize.height+padding;
        textPositionX=canvasX+pixelSize.width+padding+camScaledSize.width/2;
        textPositionZ=canvasZ+panelInfo.height;
        break;
    }
    return {iconPositionX:iconPositionX,
            iconPositionZ:iconPositionZ,
            textPositionX:textPositionX,
            textPositionZ:textPositionZ,
          };
  }

  const drawCams=(cams)=> {
    const existCanvas = canvasCamsRef.current ?? false;
    
    if(existCanvas){
      
      var contextCams=canvasCamsRef.current.getContext('2d');
      contextCams.clearRect(
        0, 0,
        canvasCamsRef.current.width,
        canvasCamsRef.current.height
        );
        cams.forEach((cam)=>{

        if(cam.type!="controlroom" && cam.type!="ccr"){
          
          if(cam!==holdingCam){
            drawCam(cam,contextCams);
          }
        }
      });
  }
  }

  const drawCam=(cam, ctx,selected=false,highlight=false)=> {
    if(selected){
      ctx.fillStyle = '#ff9999';
      ctx.lineWidth = 3;
    }else if(highlight){
      ctx.fillStyle = '#6CC24A';
      ctx.lineWidth = 3;
    }else{
      ctx.lineWidth=1;
    }
    ctx.strokeStyle = '#444444';
    var img = document.createElement('IMG');
    
    let canvasX=transformToCanvas("x",cam.pos.x);
    let canvasZ=transformToCanvas("z",cam.pos.z);
    let positions;
    let panelInfo={width:150,height:70};
    let rectFill="#db3700"
    // Specify the src to load the image
    if(mapModeSelected==1){ // mode web/vr
      if(highlight==true){
        if(cam.custom.highlight){
          rectFill="#e7990c";
          img.src = cam.custom.highlight.url;
        }else
          img.src = cam.img.highlight.url;
      }else if(selected==true){
        if(cam.custom.selected){
          rectFill="#e7990c";
          img.src = cam.custom.selected.url;
        }else
          img.src = cam.img.selected.url;
      }else{
        if(cam.custom.icon){
          rectFill="#e7990c";
          img.src = cam.custom.icon.url;  
        }else
          img.src = cam.img.icon.url;
      }
    }else{ //mode mobile
      if(selected==true){
        if(cam.custom.mobileSelected){
          rectFill="#e7990c";
          img.src = cam.custom.mobileSelected.url;
        }else
          img.src = cam.img.mobileSelected.url;
      }else{
        if(cam.custom.mobileIcon){
          rectFill="#e7990c";
          img.src = cam.custom.mobileIcon.url;  
        }else{
          img.src = cam.img.mobileIcon.url;
        }
      }
    }

    ctx.fillStyle = rectFill;
    ctx.fillRect(canvasX, canvasZ, pixelSize.width, pixelSize.height);
    ctx.strokeRect(canvasX, canvasZ, pixelSize.width, pixelSize.height);
    ctx.fillText(cam.i,20+ctx.width/2,20+ctx.height/2);
    img.onload = function () {
      if(!mainImg){
        return;
      }
      let imageSizeWidth=DEFAULT_WIDTH*img.width/mainImg.originalWidth*cam.scale;
      let scaledImageSize={
        width:imageSizeWidth,
        height:imageSizeWidth*img.height/img.width
      };
      if(cam.pos.x>=0.5){
        if(cam.pos.x>=0.85)
          positions=getCamPosition("left",canvasX,canvasZ,pixelSize,scaledImageSize,panelInfo);  
        else
          positions=getCamPosition("right",canvasX,canvasZ,pixelSize,scaledImageSize,panelInfo);
      }else if(cam.pos.x<=-0.5){
        if(cam.pos.x<=-0.85)
          positions=getCamPosition("right",canvasX,canvasZ,pixelSize,scaledImageSize,panelInfo);
        else
          positions=getCamPosition("left",canvasX,canvasZ,pixelSize,scaledImageSize,panelInfo);
      }else{
        if(cam.pos.z>0){
          if(cam.pos.z>=0.85)
            positions=getCamPosition("down",canvasX,canvasZ,pixelSize,scaledImageSize,panelInfo);
          else
            positions=getCamPosition("up",canvasX,canvasZ,pixelSize,scaledImageSize,panelInfo);
        }else{
          if(cam.pos.z<=-0.85)
            positions=getCamPosition("up",canvasX,canvasZ,pixelSize,scaledImageSize,panelInfo);
          else
            positions=getCamPosition("down",canvasX,canvasZ,pixelSize,scaledImageSize,panelInfo);
        }
      }
      if(highlight){
        ctx.fillStyle = '#ffffff';
        ctx.fillStroke="#000000";
        ctx.lineWidth=1;
        ctx.fillRect(positions.textPositionX-10, positions.textPositionZ-35, panelInfo.width,panelInfo.height);
        ctx.strokeRect(positions.textPositionX-10, positions.textPositionZ-35, panelInfo.width, panelInfo.height);
        ctx.fillStyle = '#444444';
        ctx.font = 'bold 8pt Verdana';
        ctx.fillText("Label: "+cam.cameraName,positions.textPositionX,positions.textPositionZ-20);
        ctx.fillText("Pos ( X: "+cam.pos.x+" , Z: "+cam.pos.z+" )",positions.textPositionX,positions.textPositionZ-5);
        ctx.fillText("Rot ( X: "+cam.rot.x+" , Y: "+cam.rot.y+" , Z: "+cam.rot.z+" )",positions.textPositionX,positions.textPositionZ+10);
        ctx.fillText("Scale ("+cam.scale+")",positions.textPositionX,positions.textPositionZ+25);
      }
      let TO_RADIANS = Math.PI/180; 
      rotateAndPaintImage ( ctx, img, cam.rot.y*TO_RADIANS, positions.iconPositionX+imageSizeWidth/2, positions.iconPositionZ+scaledImageSize.height/2, scaledImageSize.width/2, scaledImageSize.width/2,scaledImageSize.width,scaledImageSize.height);

    }
   
  }

  function rotateAndPaintImage ( context, image, angleInRad , positionX, positionZ, axisX, axisZ,width,height ) {
    context.translate( positionX, positionZ );
    context.rotate( angleInRad );
    context.drawImage( image, -axisX, -axisZ,width,height );
    context.rotate( -angleInRad );
    context.translate( -positionX, -positionZ );
  }

  const resetMap=()=>{
    var ctx = canvasImageRef.current.getContext('2d');
    ctx.reset();
    var ctx1=canvasBackgroundRef.current.getContext('2d');
    ctx1.reset();
    var ctx2=canvasSpacesRef.current.getContext('2d');
    ctx2.reset();
    var ctx3=canvasHighlightRef.current.getContext('2d');
    ctx3.reset();
  }
  const resetCams=()=>{
    var ctxH=canvasHighlightRef.current.getContext('2d');
    ctxH.reset();
    var ctxC=canvasCamsRef.current.getContext('2d');
    ctxC.reset();
  }

  const drawMap=(ctx,mapUrl,alpha="1",globalComposite="source-over",mainImg=null,func=null)=>{
    var img = document.createElement('IMG');
    let backgroundPosx,backgroundPosy;
    let pixelWidth,pixelHeight;
    let totalImageX,totalImageY;
    let imgResizedWidth,imgResizedHeight;
    img.onload = function () {
      if(mainImg){ // this draw is for the background
        let possibleWidth=mainImg.width;
        let possibleHeight =possibleWidth*img.height/img.width;
        if(possibleHeight>mainImg.height){  //resize by height 
          possibleHeight =mainImg.height;
          possibleWidth=possibleHeight*img.width/img.height;
          imgResizedWidth=possibleWidth+offsetBackground;
          imgResizedHeight=possibleHeight+offsetBackground;
        }else{ //resize by width
          imgResizedWidth=possibleWidth +offsetBackground;
          imgResizedHeight=possibleHeight +offsetBackground;
        }
        pixelWidth=mainImg.pixelWidth;
        pixelHeight=mainImg.pixelHeight;
      
          
      }else{ // this is for the main image 
        imgResizedWidth=DEFAULT_WIDTH;
        imgResizedHeight=imgResizedWidth * img.height / img.width;
        
        pixelWidth=imgResizedWidth/(numberPosX)*2;
        pixelHeight=imgResizedHeight/(numberPosZ)*2;
        setPixelSize({width:pixelWidth,height:pixelHeight});
      }
      totalImageX=pixelWidth*numberPosX;
      totalImageY=pixelHeight*numberPosZ;
      backgroundPosx=totalImageX/2 - imgResizedWidth/2+pixelWidth/2;
      backgroundPosy=totalImageY/2 - imgResizedHeight/2+pixelHeight/2;
      ctx.globalCompositeOperation = globalComposite;
      ctx.globalAlpha =alpha;// "0.8";
      ctx.drawImage(img,backgroundPosx, backgroundPosy,imgResizedWidth ,imgResizedHeight);
      ctx.globalAlpha = "1";
      if(func){
        func({url:mapUrl,pixelWidth:pixelWidth,pixelHeight:pixelHeight,width:imgResizedWidth,height:imgResizedHeight,originalWidth:img.width,originalHeight:img.height});
      }
    }
    img.src=mapUrl;
  }

  const transformToCanvas=(mode,value)=>{
    let res;
    if(mode=="x"){
      res=scale(value,new_min,new_max,minPosX,pixelSize.width*numberPosX)+padding_left;
    }else{
      res=scale(value,new_min_y,new_max_y,minPosY,pixelSize.height*numberPosZ)+padding_top;
    }
    return res;
  }

  const transformToValues=(mode,value)=>{
    let res;
    if(mode=="x")
      res=scale(value-padding_left,minPosX,numberPosX*pixelSize.width,new_min,new_max);
    else
      res=scale(value-padding_top,minPosY,numberPosZ*pixelSize.height,new_min_y,new_max_y);
    return res;
  }
  const convertValues=(mode,value)=>{
    if(mode=="x")
      return  (( ( value - -minPosX ) / (numberPosX - -minPosX) ) * (new_max - new_min) + new_min).toFixed(2);
    else
      return  (( ( value - -minPosY ) / (numberPosZ - -minPosY) ) * (new_max - new_min) + new_min).toFixed(2);
  }

  const handlePopupClose=()=>{
    setShowPopup(false);
    drawCams(cams);
  }
  const handlePopupSubmit=()=>{
  }
  const handlePopupSave=()=>{
    let newData=popupData;
    if(newValues && newValues.custom && newValues.img){
      if(newValues.custom.icon && newValues.custom.icon.id==null){
        newValues.custom.icon=cams[newData.i].img.icon;
      }
      if(newValues.custom.highlight && newValues.custom.highlight.id==null){
        newValues.custom.highlight=cams[newData.i].img.highlight;
      }
      if(newValues.custom.selected && newValues.custom.selected.id==null){
        newValues.custom.selected=cams[newData.i].img.selected;
      }
      if(newValues.custom.mobileIcon && newValues.custom.mobileIcon.id==null){
        newValues.custom.mobileIcon=cams[newData.i].img.mobileIcon;
      }
      if(newValues.custom.mobileSelected && newValues.custom.mobileSelected.id==null){
        newValues.custom.mobileSelected=cams[newData.i].img.mobileSelected;
      }
      cams[newData.i]=newValues;
      drawCams(cams);
      let newValue = updateValue(cams);
      if(newValue!=null){
        onUpdate({ target: { value: newValue }});
      }
    }
    setShowPopup(false);
  }
  const updateValue=(cams)=>{
    let newValue=[...value];
    let updated=false;
    newValue.forEach((c,index)=>{
      if(c.type=="180" || c.type=="360" || c.type=="globe" ||c.type=="flat"){
        if(parseFloat(c.viewPoint[0].positionX) != parseFloat(cams[index].pos.x)||
            parseFloat(c.viewPoint[0].positionY)!=parseFloat(cams[index].pos.y)||
            parseFloat(c.viewPoint[0].positionZ)!=parseFloat(cams[index].pos.z) ||
            parseFloat(c.viewPoint[0].rotationX)!=parseFloat(cams[index].rot.x) ||
            parseFloat(c.viewPoint[0].rotationY)!=parseFloat(cams[index].rot.y) ||
            parseFloat(c.viewPoint[0].rotationZ)!=parseFloat(cams[index].rot.z)){
          updated=true;
          c.viewPoint[0].positionX = parseFloat(cams[index].pos.x);
          c.viewPoint[0].positionY=parseFloat(cams[index].pos.y);
          c.viewPoint[0].positionZ=parseFloat(cams[index].pos.z);
          c.viewPoint[0].rotationX=parseFloat(cams[index].rot.x);
          c.viewPoint[0].rotationY=parseFloat(cams[index].rot.y);
          c.viewPoint[0].rotationZ=parseFloat(cams[index].rot.z);
        }
        let res=updateCam(c.viewPoint[0],cams[index].custom);
        c.viewPoint[0]=res.viewPoint;
        if(res.updated)
          updated=true;
        if(parseFloat(c.viewPoint[0].scale)!=parseFloat(cams[index].scale)){
          updated=true;
          c.viewPoint[0].scale=parseFloat(cams[index].scale);
        }
      }
    });

    if(updated==false)
      return null;
    else
      return newValue;
  }
  const updateCam=(viewPoint,customImages)=>{
    let updated=false;
    if(viewPoint.icon!=customImages.icon){
      viewPoint.icon=customImages.icon;
      updated=true;
    }
    if(viewPoint.highlight!=customImages.highlight){
      viewPoint.highlight=customImages.highlight;
      updated=true;
    }
    if(viewPoint.selected!=customImages.selected){
      viewPoint.selected=customImages.selected;
      updated=true;
    }
    if(viewPoint.mobileIcon!=customImages.mobileIcon){
      viewPoint.mobileIcon=customImages.mobileIcon;
      updated=true;
    }
    if(viewPoint.mobileSelected!=customImages.mobileSelected){
      viewPoint.mobileSelected=customImages.mobileSelected;
      updated=true;
    }
    return {"updated":updated,"viewPoint":viewPoint};
  }

  const handleDblClick=(e)=> {
    var cam;
    let c=findCamera();
    for (var index = 0; index < cams.length; index++) {
      cam = cams[index];
      var realX=parseFloat(e.clientX)-canvasDragRef.current.getBoundingClientRect().x;
      var realY=parseFloat(e.clientY)-canvasDragRef.current.getBoundingClientRect().y;
      setOffset({x:canvasDragRef.current.getBoundingClientRect().x,y:canvasDragRef.current.getBoundingClientRect().y});
      let canvasX=transformToCanvas("x",cam.pos.x);
      let canvasZ=transformToCanvas("z",cam.pos.z);

      if (realX >= canvasX && realX < pixelSize.width + canvasX
        && realY >= canvasZ && realY < pixelSize.height + canvasZ)
      {
        setPopupData(cam);
        setPopupValues(cam);
        setShowPopup(true);
        break;
      }
    }
  }
  const findCamera=()=>{
    let find = cams.find((x=>x.selected==true));
    if(find)
      return findCamera;
    else
       return null;
  }
  const handleDragMouseDown = (e) =>{
    var cam;
    setIsMouseDown(true);
    for (var index = 0; index < cams.length; index++) {
      cam = cams[index];
      if(cam.type!="controlroom" && cam.type!="ccr"){
        var realX=parseFloat(e.clientX)-canvasDragRef.current.getBoundingClientRect().x;
        var realY=parseFloat(e.clientY)-canvasDragRef.current.getBoundingClientRect().y;
        setOffset({x:canvasDragRef.current.getBoundingClientRect().x,y:canvasDragRef.current.getBoundingClientRect().y});
        let canvasX=transformToCanvas("x",cam.pos.x);
        let canvasZ=transformToCanvas("z",cam.pos.z);

        if (realX >= canvasX && realX < pixelSize.width + canvasX
          && realY >= canvasZ && realY < pixelSize.height + canvasZ)
        {
          
          holdingCam=cam; 
          setCursorOffset({
            x: realX - canvasX,
            y: realY - canvasZ
          });
          drawCams(cams);
          var contextDrags=canvasDragRef.current.getContext('2d');
          contextDrags.clearRect(0, 0,
            canvasDragRef.current.width,
            canvasDragRef.current.height,
          );
          drawCam(cam, contextDrags,true);
          break;
        }
      }
    }
  };
  

  const  handleDragMouseUp = (e)=> {
    setCursorOffset(null);
    setIsMouseDown(false);
    var didMatch=false;
    var contextCams=canvasCamsRef.current.getContext('2d');
    if(cursorOffset!=null){
      var cam=holdingCam;
      setCursorOffset(null);
      if(cam && cam.pos){
        for (var index = 0; index < spaces.length; index++) {
          var space = spaces[index];
          let canvasX=transformToCanvas("x",cam.pos.x);
          let canvasZ=transformToCanvas("z",cam.pos.z);
          if (Math.abs(canvasX - space.x) < (pixelSize.width / 1.5)
            && Math.abs(canvasZ - space.z) < (pixelSize.height / 1.5)
          ) {
            cam.pos.x = transformToValues("x",space.x).toFixed(2);
            cam.pos.z = transformToValues("z",space.z).toFixed(2);
            didMatch = true;
            
            break;
          }
          cam.selected=false;
        }
      }
    }
    setTimeout(()=>{
     
        if (didMatch) {
          for (var index = 0; index < cams.length; index++) {
            cams[index].selected=false;
          }
          setCams(cams);
          
        
        var contextDrag=canvasDragRef.current.getContext('2d');
        contextDrag.clearRect(0, 0,
          canvasCamsRef.current.width,
          canvasCamsRef.current.height
        );
        let newValue=updateValue(cams);
        if(newValue!=null){
          
          onUpdate({ target: { value: newValue }});
        }
      }
      holdingCam=null;
    },0);
    
   
    
    
  };

  const handleDragMouseMove=(e)=>{
    if (cursorOffset && holdingCam != null) {
      var cam = holdingCam;
      let temp_x=transformToValues("x",e.clientX-offset.x).toFixed(2);
      let temp_z= transformToValues("z",e.clientY -offset.y).toFixed(2);
      cam.pos.x =(temp_x>1?1:(temp_x<-1?-1:temp_x));
      cam.pos.z = (temp_z>1?1:(temp_z<-1?-1:temp_z));
      var contextDrag=canvasDragRef.current.getContext('2d');
      contextDrag.clearRect(0, 0,
        canvasDragRef.current.width,
        canvasDragRef.current.height,
      );

      drawCam(cam, contextDrag,true);
      var contextHighlight=canvasHighlightRef.current.getContext('2d');
  
      contextHighlight.clearRect(0, 0,
        canvasHighlightRef.current.width,
        canvasHighlightRef.current.height,
      );
    }else{
      // isCameraHere(cam,e.clientX,e.clientY);
      for (var index = 0; index < cams.length; index++) {
        cam = cams[index];
        if(cam.type!="controlroom" && cam.type!="ccr"){
          var realX=parseFloat(e.clientX)-canvasDragRef.current.getBoundingClientRect().x;
          var realY=parseFloat(e.clientY)-canvasDragRef.current.getBoundingClientRect().y;
          setOffset({x:canvasDragRef.current.getBoundingClientRect().x,y:canvasDragRef.current.getBoundingClientRect().y});
          let canvasX=transformToCanvas("x",cam.pos.x);
          let canvasZ=transformToCanvas("z",cam.pos.z);
         
          if (realX >= canvasX && realX < pixelSize.width + canvasX
            && realY >= canvasZ && realY < pixelSize.height + canvasZ)
          {
            highlightCam=cam; 
            cams[index].selected=true;
            setCursorOffset({
              x: realX - canvasX,
              y: realY - canvasZ
            });
            var contextHighlight=canvasHighlightRef.current.getContext('2d');
    
            drawCam(cam, contextHighlight,false,true);
            break;
          }else{
              var contextHighlight=canvasHighlightRef.current.getContext('2d');
              contextHighlight.clearRect(0, 0,
                canvasHighlightRef.current.width,
                canvasHighlightRef.current.height,
              );
              if(cams[index].selected==true){
                var contextCam=canvasCamsRef.current.getContext('2d');
                drawCam(cam, contextCam,false,false);
              }
          }
        }
      }
    }
  };
  const onPopupImageChange=(data,imageField)=>{
    let currentV={...popupValues};
    if(data.id==null)
      data=null;
    switch(imageField){
      case "camImage":
        currentV.custom.icon=data;
      break;
      case "camHighlighted":
        currentV.custom.highlight=data;
      break;
      case "camSelected":
        currentV.custom.selected=data;
      break;
      case "camMobile":
        currentV.custom.mobileIcon=data;
      break;
      case "camMobileSelected":
        currentV.custom.mobileSelected=data;
      break;
    }

    setNewValues({...popupValues,...{["img"]:currentV.img}});
  }
  const onPopupChange=(e,field)=>{
    let newPos=popupData.pos;
    let newRot=popupData.rot;
    let newScale=popupData.scale;
    let newName=popupData.name;
    let newCameraName=popupData.cameraName;
    let value=parseFloat(e.target.value);
    switch(field){
      case "rotationZ":
        newRot.z=value;
      break;
      case "rotationX":
        newRot.x=value;
      break;
      case "rotationY":
        newRot.y=value;
      break;
      case "positionX":
        newPos.x=value;
      break;
      case "positionY":
        newPos.y=value;
      break;
      case "positionZ":
        newPos.z=value;
        break;
      case "scale":
        newScale=value;
      break;
      case "name":
        newName=e.target.value;
      break;
      case "cameraName":
        newCameraName=e.target.value;
        const newMulticamComposer = stepData.composeExperienceMulticamComposer;
        const newCameras = stepData.cameras;

        newMulticamComposer.forEach((elem,index)=>{
          if (elem.name === popupData.name)
            elem.cameraName = newCameraName;
        })
        newCameras.forEach((elem,index)=>{
          if (elem.name === popupData.name)
          elem.cameraName = newCameraName;
        })
        // We should do this "delayed update" in the inputText component, but the modal we use here is has a very different structure
        // and is not as simple as changing the component. 
        
          onUpdateCameras({composeExperienceMulticamComposer: newMulticamComposer})
          onUpdateCameras({cameras: newCameras})
      
      break;
    }
    setNewValues({...popupValues,...{["rot"]:newRot},...{["pos"]:newPos},...{["scale"]:newScale},...{["name"]:newName},...{["cameraName"]:newCameraName}});
    
  }

  const extractInfo2=(value,stepData,generic180,generic360,genericFlat)=>{
    let cams=[];
     value.forEach((elem,index)=>{
       let urlDefault=camNoImage180; //"https://ireland.origin.ybvr.com/streaming/smoketests/customassets/signalingTestAssets/testViewpoint1_default.png";
       if(elem.type=="flat")
        urlDefault=camNoImageFlat;
      else if(elem.type=="180")
         urlDefault=camNoImage180;
       else if(elem.type=="360")
         urlDefault=camNoImage360;
       else if(elem.type=="globe")
         urlDefault=camNoImage360;
        else if(elem.type=="flat")
          urlDefault=camNoImage360;

      
      let pos={x:parseFloat(elem.viewPoint[0].positionX),y:parseFloat(elem.viewPoint[0].positionY),z:parseFloat(elem.viewPoint[0].positionZ)};
      let rot={x:parseFloat(elem.viewPoint[0].rotationX),y:parseFloat(elem.viewPoint[0].rotationY),z:parseFloat(elem.viewPoint[0].rotationZ)};
      let scale=parseFloat((elem.viewPoint[0].scale?elem.viewPoint[0].scale:1));
      let image={
        icon:{url:urlDefault},
        highlight:{url:urlDefault},
        selected:{url:urlDefault},
        mobileIcon:{url:urlDefault},
        mobileSelected:{url:urlDefault},
      };
      let customImage={
        icon:null,
        highlight:null,
        selected:null,
        mobileIcon:null,
        mobileSelected:null
      };
      let imageSet={};
      if(elem.type==180){
        imageSet=getImage(image,customImage,elem.viewPoint[0],generic180,"icon180","icon",elem.type);
        imageSet=getImage(image,customImage,elem.viewPoint[0],generic180,"highlight180","highlight",elem.type);
        imageSet=getImage(image,customImage,elem.viewPoint[0],generic180,"selected180","selected",elem.type);
        imageSet=getImage(image,customImage,elem.viewPoint[0],generic180,"mobileIcon180","mobileIcon",elem.type);
        imageSet=getImage(image,customImage,elem.viewPoint[0],generic180,"mobileSelected180","mobileSelected",elem.type);
      }
      else if(elem.type==360){
        imageSet=getImage(image,customImage,elem.viewPoint[0],generic360,"icon360","icon",elem.type);
        imageSet=getImage(image,customImage,elem.viewPoint[0],generic360,"highlight360","highlight",elem.type);
        imageSet=getImage(image,customImage,elem.viewPoint[0],generic360,"selected360","selected",elem.type);
        imageSet=getImage(image,customImage,elem.viewPoint[0],generic360,"mobileIcon360","mobileIcon",elem.type);
        imageSet=getImage(image,customImage,elem.viewPoint[0],generic360,"mobileSelected360","mobileSelected",elem.type);
      }
      else if(elem.type=='globe'){
        imageSet=getImage(image,customImage,elem.viewPoint[0],generic360,"icon360","icon",elem.type);
        imageSet=getImage(image,customImage,elem.viewPoint[0],generic360,"highlight360","highlight",elem.type);
        imageSet=getImage(image,customImage,elem.viewPoint[0],generic360,"selected360","selected",elem.type);
        imageSet=getImage(image,customImage,elem.viewPoint[0],generic360,"mobileIcon360","mobileIcon",elem.type);
        imageSet=getImage(image,customImage,elem.viewPoint[0],generic360,"mobileSelected360","mobileSelected",elem.type);
      }
      else if(elem.type=='flat') {
        imageSet=getImage(image,customImage,elem.viewPoint[0],genericFlat,"iconFlat","icon",elem.type);
        imageSet=getImage(image,customImage,elem.viewPoint[0],genericFlat,"highlightFlat","highlight",elem.type);
        imageSet=getImage(image,customImage,elem.viewPoint[0],genericFlat,"selectedFlat","selected",elem.type);
        imageSet=getImage(image,customImage,elem.viewPoint[0],genericFlat,"mobileIconFlat","mobileIcon",elem.type);
        imageSet=getImage(image,customImage,elem.viewPoint[0],genericFlat,"mobileSelectedFlat","mobileSelected",elem.type);

      }
      
      if (elem.type!='croom')
      {
        cams.push({
            i:index,
            name:elem.name,
            cameraName:elem.cameraName,
            pos:pos,
            rot:rot,
            scale:scale,
            img:imageSet.image,
            custom:imageSet.customImage,
            type:elem.type,
            selected:false
        });
      }
    });
    return cams;
  }

  const getImage=(image,customImage,viewPointImage,genericImages,iconField,field,type)=>{
    let urlDefault=camNoImage180; //"https://ireland.origin.ybvr.com/streaming/smoketests/customassets/signalingTestAssets/testViewpoint1_default.png";
      if(type=="flat")
        urlDefault=camNoImageFlat; 
      else if(type=="180")
         urlDefault=camNoImage180;
       else if(type=="360")
         urlDefault=camNoImage360;
         else if(type=="globe")
         urlDefault=camNoImage360;
    if(Object.keys(genericImages.changes).length==0){ //no changes in images so set the viewpoint and if not the default from mapconfig
      if(viewPointImage && viewPointImage[field] && viewPointImage[field].url){
        customImage[field]= viewPointImage[field];
        return {"image":image,"customImage":customImage};
      }else{
        
        if(genericImages.values && genericImages.values[field] && genericImages.values[field].url){
          image[field].url=genericImages.values[field].url;
          return {"image":image,"customImage":customImage};
        }else
          image[field].url=urlDefault;
          return {"image":image,"customImage":customImage};
      }
    }else{ //if there are changes on the mapconfig then set the mapconfig change as camera image.
      if(genericImages.changes[field].url){
          image[field].url=genericImages.values[field].url;
          customImage[field].url=null;
          return {"image":image,"customImage":customImage};
      }else{
        if(viewPointImage && viewPointImage[field] && viewPointImage[field][0].url){
          customImage[field].url= viewPointImage[field][0].url;
          return {"image":image,"customImage":customImage};
        }else{
          image[field].url=genericImages.values[field].url;
          customImage[field].url=null;
          return {"image":image,"customImage":customImage};
        }
      }
    }
  }
  const changesInCameras=(cameraType, camera)=>{
    switch(cameraType){
      case "180":
        if(icon180==null && Object.keys(camera).length==3){
          return true;
        }
        if(icon180 && camera && camera.icon && icon180.icon!=camera.icon)
          return true;
        if(icon180 && camera && camera.highlight && icon180.highlight!=camera.highlight)
          return true;
        if(icon180 && camera && camera.selected && icon180.selected!=camera.selected)
          return true;
        break;
      case "360":
        if(icon360==null && Object.keys(camera).length==3){
          return true;
        }
        if(icon360 && camera && camera.icon && icon360.icon!=camera.icon)
          return true;
        if(icon360 && camera && camera.highlight && icon360.highlight!=camera.highlight)
          return true;
        if(icon360 && camera && camera.selected && icon360.selected!=camera.selected)
          return true;
        break;
      case "globe":
        if(icon360==null && Object.keys(camera).length==3){
          return true;
        }
        if(icon360 && camera && camera.icon && icon360.icon!=camera.icon)
          return true;
        if(icon360 && camera && camera.highlight && icon360.highlight!=camera.highlight)
          return true;
        if(icon360 && camera && camera.selected && icon360.selected!=camera.selected)
          return true;
        break;
      case "flat":
        if(icon360==null && Object.keys(camera).length==3){
          return true;
        }
        if(iconFlat && camera && camera.icon && iconFlat.icon!=camera.icon)
          return true;
        if(iconFlat && camera && camera.highlight && iconFlat.highlight!=camera.highlight)
          return true;
        if(iconFlat && camera && camera.selected && iconFlat.selected!=camera.selected)
          return true;
        break;
    }
    return false;
  }
  
  let numCams =0;
  if(value)
    {
      numCams=value.filter(elem=>(elem.type=="180" || elem.type=="360" || elem.type=="flat" || elem.type=="globe"));
    }

  return (
    <div className="camera-presentation-preview" style={{width:mainWidth,height:mainHeight}}>
       <ButtonGroup className="toggle-button">
            {viewMapModes.map((mode, idx) => (
              <ToggleButton
                key={idx}
                className={idx % 2 ? 'toggle-right' : 'toggle-left'}
                id={`mode-${idx}`}
                type="radio"
                value={mode.value}
                checked={mapModeSelected === mode.value}
                onChange={(e) => changeMapMode(e.currentTarget.value)}
              >
                {mode.name}
            </ToggleButton>
          ))}
        </ButtonGroup>
    {preview && spaces.length==0 && <div className="camera-presentation-loading">LOADING...</div>}
    {!preview && <div className="camera-presentation-no-images"><div>NO IMAGES FOUND<br/>{(numCams.length>0?"Num cams on this live ("+numCams.length+")":"")}</div></div>}
    {cams && spaces && mainWidth && mainHeight && <div className="camera-presentation-block">
      <canvas id="spaces" width={mainWidth} height={mainHeight} className="canvas-layer" ref={canvasSpacesRef}/>
      <canvas id="background" width="870" height="870" className="canvas-layer" ref={canvasBackgroundRef}/>
      <canvas id="image" width="870" height="870" className="canvas-layer" ref={canvasImageRef}/>
      <canvas id="cams" width={mainWidth} height={mainHeight} className="canvas-layer" ref={canvasCamsRef}/>
      <canvas id="highlight" width={mainWidth} height={mainHeight} className="canvas-layer" ref={canvasHighlightRef}/>
      <canvas id="drag" width={mainWidth} height={mainHeight} className="canvas-layer" ref={canvasDragRef} onDoubleClick={handleDblClick} onMouseDown={handleDragMouseDown}  onMouseUp={handleDragMouseUp}  onMouseMove={handleDragMouseMove}/>
      <ModalBootstrap size={'lg'}
        show={showPopup}
        onHide={handlePopupClose}
        >
        <ModalBootstrap.Header closeButton>
          <ModalBootstrap.Title>Info</ModalBootstrap.Title>
        </ModalBootstrap.Header>
        <ModalBootstrap.Body>
          <Form onSubmit={handlePopupSubmit}>
            {/* <Form.Label>Camera1: {(popupData?popupData.name:"")}</Form.Label> */}
            <Row>
              <Col>
                <Form.Group controlId="formPositionX">
                <Form.Label>{popupData?.cameraName ? 'Camera ':''}Name</Form.Label>
                  {
                    popupData?.cameraName ? 
                    <Form.Control type="text" 
                    placeholder="Camera Name..." 
                    defaultValue={(popupData?popupData.cameraName:"")}
                    required={true}
                    onChange={(e)=>{onPopupChange(e,"cameraName")}}/>
                    :
                    <Form.Control type="text" 
                    placeholder="Name..." 
                    defaultValue={(popupData?popupData.name:"")}
                    required={true}
                    onChange={(e)=>{onPopupChange(e,"name")}}/>
                  }
                 
                </Form.Group> 
              </Col>
              
            </Row>
            <Row>
              <Col>
                <Form.Group controlId="formPositionX">
                <Form.Label>Position X</Form.Label>
                  <Form.Control type="text" 
                    placeholder="PositionX..." 
                    defaultValue={(popupData?popupData.pos.x:"")}
                    required={true}
                    onChange={(e)=>{onPopupChange(e,"positionX")}}/>
                </Form.Group> 
              </Col>
              <Col>
                <Form.Group controlId="formPositionY">
                <Form.Label>Position Y</Form.Label>
                  <Form.Control type="text" 
                    placeholder="PositionY..." 
                    defaultValue={(popupData?popupData.pos.y:"")}
                    required={true}
                    onChange={(e)=>{onPopupChange(e,"positionY")}}/>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="formPositionZ">
                <Form.Label>Position Z</Form.Label>
                  <Form.Control type="text" 
                    placeholder="PositionZ..." 
                    defaultValue={(popupData?popupData.pos.z:"")}
                    required={true}
                    onChange={(e)=>{onPopupChange(e,"positionZ")}}/>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group controlId="formRotationX">
                <Form.Label>Rotation X</Form.Label>
                  <Form.Control type="text" 
                    placeholder="RotationX..." 
                    defaultValue={(popupData?popupData.rot.x:"")}
                    required={true}
                    onChange={(e)=>{onPopupChange(e,"rotationX")}}/>
                </Form.Group> 
              </Col>
              <Col>
                <Form.Group controlId="formRotationY">
                <Form.Label>Rotation Y</Form.Label>
                  <Form.Control type="text" 
                    placeholder="RotationY..." 
                    defaultValue={(popupData?popupData.rot.y:"")}
                    required={true}
                    onChange={(e)=>{onPopupChange(e,"rotationY")}}/>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="formRotationZ">
                <Form.Label>Rotation Z</Form.Label>
                  <Form.Control type="text" 
                    placeholder="RotationZ..." 
                    defaultValue={(popupData?popupData.rot.z:"")}
                    required={true}
                    onChange={(e)=>{onPopupChange(e,"rotationZ")}}/>
                </Form.Group>
              </Col>
            </Row>
            <Form.Group controlId="formScale">
              <Form.Label>Scale</Form.Label>
              <Form.Control type="text" 
                  placeholder="Scale..."
                  defaultValue={(popupData?popupData.scale:"")} 
                  required={true}
                  onChange={(e)=>{onPopupChange(e,"scale")}}/>
            </Form.Group>
            <Row>
              <Col>
                <FormExternalResource
                    id={"myimage"}
                    type={ FormInputTypes.DOWNLOADABLE}
                    key={"myimage"}
                    label={"Image"}
                    helpText={"Set custom image for this camera"}
                    fileType={['image/*']}
                    value={(popupData && popupData.custom.icon?popupData.custom.icon.id:"")}
                    onChange={(data) => {onPopupImageChange(data,"camImage")}}
                    hasSelect={false}
                    canUpdate={false}
                    size={'L'}
                  />
              </Col>
              <Col>
                <FormExternalResource
                  id={"myimageHighlighted"}
                  type={ FormInputTypes.DOWNLOADABLE}
                  key={"myimageHighlighted"}
                  label={"Highlighted Image"}
                  helpText={"Set custom image for this camera"}
                  fileType={['image/*']}
                  value={(popupData && popupData.custom.highlight?popupData.custom.highlight.id:"")}
                  onChange={(data) => {onPopupImageChange(data,"camHighlighted")}}
                  hasSelect={false}
                  canUpdate={false}
                  size={'L'}
                />
              </Col>
              <Col>
                <FormExternalResource
                  id={"myimageSelected"}
                  type={ FormInputTypes.DOWNLOADABLE}
                  key={"myimageselected"}
                  label={"Image Selected"}
                  helpText={"Set custom image for this camera"}
                  fileType={['image/*']}
                  value={(popupData && popupData.custom.selected?popupData.custom.selected.id:"")}
                  onChange={(data) => {onPopupImageChange(data,"camSelected")}}
                  hasSelect={false}
                  canUpdate={false}
                  size={'L'}
                />
              </Col>
              </Row>
              <Row>
                <Col>
                <FormExternalResource
                  id={"mobile"}
                  type={ FormInputTypes.DOWNLOADABLE}
                  key={"mobile"}
                  label={"Mobile Image"}
                  helpText={"Set custom image for this camera"}
                  fileType={['image/*']}
                  value={(popupData && popupData.custom.mobileIcon?popupData.custom.mobileIcon:"")}
                  onChange={(data) => {onPopupImageChange(data,"camMobile")}}
                  hasSelect={false}
                  canUpdate={false}
                  size={'L'}
                />
              </Col>
              <Col>
                <FormExternalResource
                  id={"mobileSelected"}
                  type={ FormInputTypes.DOWNLOADABLE}
                  key={"mobileSelected"}
                  label={"Mobile Selected"}
                  helpText={"Set custom image for this camera"}
                  fileType={['image/*']}
                  value={(popupData && popupData.custom.mobileSelected?popupData.custom.mobileSelected:"")}
                  onChange={(data) => {onPopupImageChange(data,"camMobileSelected")}}
                  hasSelect={false}
                  canUpdate={false}
                  size={'L'}
                />
              </Col>
              </Row>
          </Form>
        </ModalBootstrap.Body>
        <ModalBootstrap.Footer>
          <div style={{width:'100%'}}>
            <Button
              id={"cancel"}
              variant="secondary"
              className="btn btn-secondary float-left"
              type={"button"}
              onClick={() => handlePopupClose()}
              size={"sm"}
            >
              Back
            </Button>
            <Button
              id={"cancel"}
              variant="primary"
              className="btn btn-primary float-right"
              type={"button"}
              onClick={() => handlePopupSave()}
              size={"sm"}
            >
              Save
            </Button>
          </div>
        </ModalBootstrap.Footer>
      </ModalBootstrap>
    </div>}
    </div>
  );
};

FormCameraPresentationComponent.propTypes = {
  /**
   * Select form status, it is a FormValidation enum
   */
  validation: PropTypes.oneOf(Object.values(FormValidation)),
  /**
   * Defined text errors
   */
  errorText: PropTypes.string,
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Input help text
   */
  helpText: PropTypes.string,
  /**
   * Initial input value
   */
  value: PropTypes.oneOfType([PropTypes.array]),
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
  onNew:PropTypes.func,
};

FormCameraPresentationComponent.defaultProps = {
  validation: FormValidation.PENDING,
  errorText: '',
  label: '',
  helpText: '',
  values:[],
  configFile:{},
  mode:'',
  canCreate:true,
  canRemove:true,
  canEdit:true,
  parentId:null,
  onChange: () => {},
};

export default FormCameraPresentationComponent;
